module.exports = __webpack_public_path__ + "img/necesitas_two.0dbaac6f.png";